import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import WorkshopsList from "./pages/WorkshopsList";
import WorkshopForm from "./pages/WorkshopForm";
import Schools from "./pages/Schools";
import Lectors from "./pages/Lectors";
import LectorDetail from "./pages/LectorDetail";
import Calendar from "./pages/Calendar";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import WorkshopTypes from "./pages/WorkshopTypes";
import LectorPortal from "./pages/LectorPortal";
import AuditLog from "./pages/AuditLog";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<div />} />
            <Route path="/sprava-9k4x" element={<Login />} />
            <Route path="/lektor" element={<Login />} />

            <Route element={<ProtectedRoute roles={["admin", "user"]} />}>
              <Route element={<Layout />}>
                <Route element={<ProtectedRoute roles={["admin"]} />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/audit" element={<AuditLog />} />
                </Route>
                <Route path="/workshops" element={<WorkshopsList />} />
                <Route path="/workshop/new" element={<WorkshopForm />} />
                <Route path="/workshop/edit/:id" element={<WorkshopForm />} />
                <Route path="/schools" element={<Schools />} />
                <Route path="/lectors" element={<Lectors />} />
                <Route path="/lector/:id" element={<LectorDetail />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/workshop-types" element={<WorkshopTypes />} />
                <Route path="/notifications" element={<Notifications />} />
              </Route>
            </Route>

            <Route
              path="/lector/dashboard"
              element={
                <ProtectedRoute roles={["lector"]}>
                  <LectorPortal />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
